/*
 * Created Date: 17-01-2024, 9:54:03 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { errorMsg } from '@Core/Helpers/Message'
import { useCoreAuthActions } from '@Core/Provider/CoreAuthProvider'
import { useBreakpoints } from '@Core/hooks/useBreakpoints'
import { Divider, Typography } from '@mui/material'
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google'
import Image from 'mui-image'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { TRANSLATE_AUTH } from '../configs/const'

// import PropTypes from 'prop-types'

const SocialAuthen = props => {
	const { t } = useTranslation(TRANSLATE_AUTH)
	const { responseGoogle } = useCoreAuthActions()
	const { mobile } = useBreakpoints()
	return (
		<div className="flex flex-wrap w-full p-4 sm:p-0">
			<Divider className="order-1 w-full mb-4 sm:mb-0 sm:mt-8 sm:order-2">
				<Typography variant="M14">{mobile ? t('or') : t('or_continue_with')}</Typography>
			</Divider>
			<div className="grid order-2 w-full grid-cols-1 gap-12 sm:order-1">
				<LoginWithGoogleBtn />
			</div>

			<div className="hidden">
				<GoogleLogin
					useOneTap
					onSuccess={responseGoogle}
					onError={() => {
						console.log('Login Failed')
					}}
				/>
			</div>
		</div>
	)
}

// SocialAuthen.defaultProps = {}

// SocialAuthen.propTypes = {}

export default React.memo(SocialAuthen)

export const LoginWithGoogleBtn = props => {
	const { t } = useTranslation(TRANSLATE_AUTH)
	const { responseGoogle } = useCoreAuthActions()
	const loginWithGoogle = useGoogleLogin({
		onSuccess: async response => {
			await responseGoogle(response)
		},
		onError: () => {
			errorMsg(t('message.login_failed_social'))
		}
	})
	return (
		// eslint-disable-next-line jsx-a11y/no-static-element-interactions
		<div
			onClick={() => loginWithGoogle()}
			className="flex items-center gap-2 px-4 py-2 text-white duration-500 border rounded-lg shadow-md cursor-pointer sm:px-8 sm:py-2 hover:transition-all hover:shadow-lg hover:font-bold bg-mainGradient hover:-translate-y-[2px]"
		>
			<div className="w-[40px] aspect-square">
				<Image src="/assets/images/auth/google_icon.png" alt="google" />
			</div>

			<Typography className="w-full text-center text-[1rem]  font-600">{t('login_with_google')}</Typography>
		</div>
	)
}

// export const LoginFaceBookBtn = props => {
// 	const { t } = useTranslation('auth')
// 	const { responseFacebook } = useCoreAuthActions()

// 	return (
// 		<FacebookLogin
// 			appId={SOCIAL_AUTH_CLENT_ID.facebook}
// 			children={
// 				<div className="flex bg-white items-center gap-6 p-6 px-12 transition-all duration-200 border rounded-lg shadow-sm cursor-pointer hover:shadow-xl hover:-translate-y-[1px] hover:bg-gray-50 hover:text-blue-500">
// 					<div className="relative w-[40px] aspect-square">
// 						<Image src="/assets/images/logo/facebook_icon.png" layout="fill" alt="facebook_login" />
// 					</div>

// 					<Typography className="w-full text-center text-[11px] sm:text-10 font-600">
// 						{t('login_with_facebook')}
// 					</Typography>
// 				</div>
// 			}
// 			onSuccess={responseFacebook}
// 			onFail={() => t('message.login_failed_social')}
// 			onProfileSuccess={response => {
// 				console.log('Get Profile Success!', response)
// 			}}
// 			scope={'email,public_profile'}
// 			fields={'name,email,picture'}
// 		/>
// 	)
// }
